module.exports = "./img/4f01f5cc2cdf40d2715e24f470778c7d.jpg";